import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-salesapproval',
  templateUrl: './salesapproval.component.html',
  styleUrls: ['./salesapproval.component.scss']
})
export class SalesapprovalComponent implements OnInit {

  salesList: any[] = [];
  selectedSale: any = null;
  From: string;
  To: string;

  constructor(public AppService: AppService, public datePipe: DatePipe) {
    this.From = this.datePipe.transform(new Date(), 'yyyy-MM-dd')!;
    this.To = this.datePipe.transform(new Date(), 'yyyy-MM-dd')!;
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
  this.AppService.get('api/transaction/get_salesapproval').subscribe({
    next: (res: any) => {
      const data = typeof res === 'string' ? JSON.parse(res) : res;

      if (data && Array.isArray(data.record)) {
        
        this.salesList = data.record.map(r => ({
          iid: r.iid,
          Barcode: r.Barcode,
          StoreName: r['Store Name']           
          // Qty: r.Qty,            
          // Tax: r.Tax,             
          // Total: r.Total          
        }));
      } else {
        this.salesList = [];
      }

      console.log('Loaded salesList:', this.salesList);
    },
    error: (err) => alert('Failed to load data: ' + err.message)
  });
}


  selectRow(sale: any) {
    this.selectedSale = sale;
    console.log('Selected sale:', sale);
  }
 approveSelected() {
  if (!this.selectedSale) {
    alert('Please select a row first.');
    return;
  }

  if (!confirm('Are you sure you want to approve this record?')) return;

  
  this.AppService.get(`api/transaction/approvesale/${this.selectedSale.iid}`)
    .subscribe({
      next: (res: any) => {
        alert(res?.message || 'Approved successfully!');
        this.selectedSale = null;
        this.loadData();
      },
      error: (err) => alert('Error approving record: ' + err.message)
    });
}

rejectSelected() {
  if (!this.selectedSale) {
    alert('Please select a row first.');
    return;
  }

  if (!confirm('Are you sure you want to reject this record?')) return;

  
  this.AppService.get(`api/transaction/rejectsale/${this.selectedSale.iid}`)
    .subscribe({
      next: (res: any) => {
        alert(res?.message || 'Rejected successfully!');
        this.selectedSale = null;
        this.loadData();
      },
      error: (err) => alert('Error rejecting record: ' + err.message)
    });
}

}
